import { useEffect } from "react";
import { useTranslation } from "react-i18next";

function ensureMeta(name) {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  return el;
}

function ensureMetaProperty(property) {
  let el = document.querySelector(`meta[property="${property}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("property", property);
    document.head.appendChild(el);
  }
  return el;
}

function ensureLink(rel) {
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  return el;
}

export default function SEO({ pageKey = "home", path = "/", image = "/images/og-main.jpg" }) {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const title = t(`seo.${pageKey}.title`, "Shawarma Dose");
    const description = t(
      `seo.${pageKey}.description`,
      "Shawarma Dose — A taste to remember"
    );

    const originEnv = process.env.REACT_APP_SITE_URL;
    const origin = originEnv && originEnv.trim().length > 0
      ? originEnv.replace(/\/$/, "")
      : (typeof window !== "undefined" && window.location.origin
        ? window.location.origin
        : "https://example.com");
    const url = origin + path;

    // Document title
    document.title = title;

    // Html attributes
    const lang = i18n.language || "ar";
    const dir = lang.startsWith("ar") ? "rtl" : "ltr";
    document.documentElement.setAttribute("lang", lang);
    document.documentElement.setAttribute("dir", dir);

    // Basic meta
    ensureMeta("description").setAttribute("content", description);

    // Canonical
    ensureLink("canonical").setAttribute("href", url);

    // hreflang alternates
    const linkAr = ensureLink("alternate");
    linkAr.setAttribute("hreflang", "ar");
    linkAr.setAttribute("href", url + (lang.startsWith("ar") ? "" : "?lang=ar"));

    const linkEn = document.createElement("link");
    linkEn.setAttribute("rel", "alternate");
    linkEn.setAttribute("hreflang", "en");
    linkEn.setAttribute("href", url + (lang.startsWith("en") ? "" : "?lang=en"));
    // avoid duplicates each render
    const existingEn = document.querySelector('link[rel="alternate"][hreflang="en"]');
    if (existingEn) existingEn.remove();
    document.head.appendChild(linkEn);

    const linkXd = document.createElement("link");
    linkXd.setAttribute("rel", "alternate");
    linkXd.setAttribute("hreflang", "x-default");
    linkXd.setAttribute("href", url);
    const existingXd = document.querySelector('link[rel="alternate"][hreflang="x-default"]');
    if (existingXd) existingXd.remove();
    document.head.appendChild(linkXd);

    // Open Graph
    ensureMetaProperty("og:site_name").setAttribute("content", "Shawarma Dose");
    ensureMetaProperty("og:type").setAttribute("content", "website");
    ensureMetaProperty("og:title").setAttribute("content", title);
    ensureMetaProperty("og:description").setAttribute("content", description);
    ensureMetaProperty("og:url").setAttribute("content", url);
    ensureMetaProperty("og:image").setAttribute("content", image);
    ensureMetaProperty("og:locale").setAttribute(
      "content",
      lang.startsWith("ar") ? "ar_AE" : "en_US"
    );

    // Twitter
    ensureMeta("twitter:card").setAttribute("content", "summary_large_image");
    ensureMeta("twitter:title").setAttribute("content", title);
    ensureMeta("twitter:description").setAttribute("content", description);
    ensureMeta("twitter:image").setAttribute("content", image);
  }, [pageKey, path, image, t, i18n.language]);

  return null;
}
